import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'

interface getUserPlansProps {
  locale: PageLocaleEnum
}

export const getUserPlans = ({ locale }: getUserPlansProps) => {
  return monolithHttpClient.get(`/user-plans/${locale}`)
}
